import { Component, HostListener, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
isDropdownActive(arg0: string[]): any {
throw new Error('Method not implemented.');
}
  isNavbarCollapsed: boolean = true;
  openDropdown: string | null = null;
  screenWidth: number = window.innerWidth;
  isMobile: boolean = this.screenWidth < 1024;
  currentRoute: string = '';

  constructor(private router: Router) {}

  ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.currentRoute = event.urlAfterRedirects;
      });
  }

  toggleNavbar() {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
    const toggler = document.querySelector('.navbar-toggler');
    toggler?.classList.toggle('active', !this.isNavbarCollapsed);
  }

  toggleDropdown(dropdown: string, event?: Event) {
    if (this.isMobile) {
      event?.preventDefault();
      this.openDropdown = this.openDropdown === dropdown ? null : dropdown;
    }
  }

  closeNavbar() {
    this.isNavbarCollapsed = true;
    this.openDropdown = null;
  }

  onMouseEnter(dropdown: string) {
    if (!this.isMobile) this.openDropdown = dropdown;
  }

  onMouseLeave() {
    if (!this.isMobile) this.openDropdown = null;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth = window.innerWidth;
    this.isMobile = this.screenWidth < 1024;
    if (!this.isMobile) {
      this.isNavbarCollapsed = true;
      this.openDropdown = null;
    }
  }

  // Check if a route is active
  isActiveRoute(routePrefix: string): boolean {
    return this.currentRoute.startsWith(routePrefix);
  }
}
